import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "../Global.js";
import { Autoplay, Navigation } from "swiper";
import EffectSlicer from "./effect-slicer.esm.js";
import "./effect-slicer.scss";
import "./main.scss";
import ReactHtmlParser from "html-react-parser";

import "swiper/scss";
import "swiper/scss/autoplay";
import "swiper/scss/navigation";

const strapiServerUrl = window.strapiServerUrl;
const googleAppLink = window.googleAppLink;
const appleAppLink = window.appleAppLink;

export default function SwiperSlider({ slides }) {
  const slide = slides;
  return (
    <Swiper
      className="swiper-slide"
      modules={[Autoplay, Navigation, EffectSlicer]}
      effect="slicer"
      direction="horizontal"
      loop={false}
      navigation={{
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      speed={1800}
    >
      {slide.map((slide, index) => (
        <SwiperSlide key={index}>
          <img
            src={`${strapiServerUrl}${slide.image}`}
            className="swiper-slicer-image"
            alt="Banner"
          />
          <div className="captions swiper-slide-content">
            <div
              className="demo-slide-title"
              style={{ color: `${slide.color ? slide.color : "#575F78"}` }}
            >
              {ReactHtmlParser(slide.desc)}
            </div>
            {slide.hasButtons && (
              <div className="Dwn-btns">
                <a
                  href={googleAppLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="download-btn">
                    <i
                      className="fab fa-google-play"
                      style={{ color: "#d40808" }}
                    ></i>
                    Download App
                  </button>
                </a>
                <a
                  href={appleAppLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="download-btn">
                    <i className="fab fa-apple fa-lg"></i>
                    Download App
                  </button>
                </a>
              </div>
            )}
          </div>
        </SwiperSlide>
      ))}
      <div className="swiper-button-prev"></div>
      <div className="swiper-button-next"></div>
    </Swiper>
  );
}
